import React, { Component, PureComponent, useContext, useState, useEffect } from 'react';
import {NavLink, Link, Switch, Route, Redirect} from 'react-router-dom'
import {RootRouterContext} from '../../index.js'
import Contact from './Contact'
import Catering from './Catering'
import Taconight from './Taconight'
import Order from './Order'
import RestaurantMap from './ReataurantMap.js';
import Headers from './Headers'
// import AutoMenu from './AutoMenu'
import AutoMenu from '../../react/AutoMenu'
import CartBar from './CartBar'
import LocationsView from './LocationsView'
import FormJob from './FormJob'
import ScrollToTop from '../../react/ScrollToTop.js';
import BakeryVideo from "./BakeryVideo"
import FeaturedProducts from './FeaturedProducts.js';
import HamburgerMenu from './HamburgerMenu.js';
import MenuCategoriesPreview from './MenuCategoriesPreview.js';
import './index.scss'
import './altStyleA.scss'
// import {PromoOverlay} from './PromoOverlay.js';
import Sushime from './Sushime.js';
import LogoBar from './svg/LogoBar'
import './ThemeToggle/theme_night.scss'
import {Helmet} from "react-helmet";
import MainNavigation from './MainNavigation.js';
import ProductSlideshow from './ProductSlideshow.js';
import { InstagramEmbed } from 'react-social-media-embed';
import locationsData, {siteData} from './locationsData.js';
 
export const customOrderAppPaths = ["/menu", "/order"]
export const StickyTopBar = () => { return null }
 
export {locationsData as locations}

// merge locations data with locations metadata


export const pages = [
  {path: "/order", label: "Order"},
  {path: "/menu", label: "Menu"},
  {path: "/hqusers/storeRedirect/:anything", label: "Catering", hideFromNav: true, component: () => <Redirect to="/"></Redirect>},
]

export const multiSitePages = [
  // {path: "/catering", label: "Menu", component: Menu},
  // {path: "/catering", label: "Catering", component: Catering},
  {path: "/sushime", label: "Sushime", component: Sushime},
  {path: "/contact", label: "Contact", component: Contact},
  {path: "/catering", label: "Catering", component: Catering},
  {path: "/order", label: "Order", component: () => <Redirect to="/alhambra/order" />},
]

export function SiteNav ({shopId}) {

    const {rootHistory} = useContext(RootRouterContext)


    return (
      <>
      <CartBar shopId={shopId}></CartBar>
    <nav role="navigation" aria-label="navigation">
    
   
  </nav>
  </>
  )
}



export function MultilocationHome () {
  const [shops, setShops] = useState([])
  const [shop, setShop] = useState(null)
  let menuURL = `https://afoodapart.com/api/menu/sushiyu`
  // useEffect(() => {
  //   const fetchShops = async () => {
  //     // fetch 2 shops shiso and shisooaks

  //     const fetchShiso = fetch(`https://p39pffu1q4.execute-api.us-west-1.amazonaws.com/v18-sushi-mods/settings?r_id=shiso`);
  //     const fetchShisooaks = fetch(`https://p39pffu1q4.execute-api.us-west-1.amazonaws.com/v18-sushi-mods/settings?r_id=shisooaks`);
      
  //     const [shisoResponse, shisooaksResponse] = await Promise.all([fetchShiso, fetchShisooaks]);
      
  //     const shisoData = await shisoResponse.json();
  //     shisoData.text.shopId = 'shiso'
  //     const shisooaksData = await shisooaksResponse.json();
  //     shisooaksData.text.shopId = 'shisooaks'
      
  //     setShops([shisoData.text, shisooaksData.text]);
  //   }
  //   fetchShops()
  // }, [0])
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await fetch(menuURL);
        const data = await response.json();
        console.log('Fetched menu data:', data.menu.subMenus);
        setShop(data);
      } catch (error) {
        console.error('Error fetching menu:', error);
      }
    };
    fetchMenu();
  }, []);

  // console.log("shops:", shops)


  const theme = "light"
  const heroLogoUrl = (theme !== 'dark') ?
    "https://afag.imgix.net/the-kluckin-chicken/kluckin-chicken-logo-1.png?w=500&auto=format" :
    "https://afag.imgix.net/the-kluckin-chicken/kluckin-chicken-logo-1.png?w=500&auto=format"

  return(
    <div className={"site-content dark-mode pablitoschicken" + " " + theme}>
      <Headers></Headers>

      <div role="navigation" aria-label="primary" className="cart-wrapper">
      
            <div className="cart minimized">
              <div className="home-link-wrapper">
                <h2>
                  <Link to="/" 
                  aria-label={"Sushi Yu Los Angeles"}
                  className="home-link" aria-label="home page">
                         {/* <img
                          className="nav-bar-logo"
                          src={"https://afag.imgix.net/pablitos-pizza/logo.png?h=400&auto=format"}
                          alt="Pablito's Mexican Pizza"
                        /> */}
                    <img
                          className="nav-bar-logo"
                          src={"https://afag.imgix.net/sushi-yu/logo-wide.png?w=800&auto=format"}
                          alt="Sushi Yu Los Angeles"
                   />
                    {/* <span className="text-logo">{!logo && shop.name && shop.name.en}</span> */}
                  </Link>
                </h2>
      
              </div>
      
             
      
              <div className="site-nav-bar" >
                  <MainNavigation />

                  <a className="nav-bar-link call-to-action" href="/alhambra/order" aria-label="order online for pickup or delivery">
                    Order
                  </a>


           
              </div>


              
      
        
            </div>
              <div className="sit-top-promo-banner-wrapper">
                <Link to="/alhambra/order">20% OFF Most Categories &mdash; Every Day</Link>
              </div>
          </div>


  
      <Switch>

        {multiSitePages.map((page) => (
          <Route key={page.path} path={page.path} component={page.component} />
        ))}
        <Route path="/" exact render={() => {
          return(<MultiHeader shops={shops} shop={shop}></MultiHeader>)
        }}></Route>
        <Route path="/bogo" render={() => {
          return(<Redirect to="/"></Redirect>)
        }}></Route>
        <Route path="/hqusers/storeRedirect/:anything" render={() => {
          return(<Redirect to="/"></Redirect>)
        }}></Route>
        {/* <MultiHeader></MultiHeader> */}
      </Switch>
    </div>
  )
}



function MultiHeader({shops, shop}) {
  const [open, setOpen] = useState(true);
  return (
    <div className="landing-page-wrapper">
    
      <div className="home-grid">
        {/* <PromoOverlay
         isOpen={open}
          onClose={() => setOpen(false)}
          imageSrc="https://afag.imgix.net/sushi-yu/bogo-sushi.png?w=800&h=800&fit=crop&crop=top&auto=format"
          imageAlt="sushi yu bogo sushi promotion"
          title="Buy One Get One 50% Off Sushi Rolls!"
          text="Limited time only."
          ctaLabel="Order for Pickup or Delivery"
          ctaHref="/alhambra/order"
          initialFocus="cta"
        >
        </PromoOverlay> */}

        {shop ? <ProductSlideshow
          ratio="4 / 3"
         categories={shop.menu.subMenus}></ProductSlideshow> : null}
        <div className="logo-hero-block" ><div className="logo-hero-block-img-wrapper"><img src="https://afag.imgix.net/sushi-yu/logo-round.png?w=900&auto=format" alt="Sushi Yu" /></div></div>

        <div className="site-intro">
          <h2 className="header-text">
           Alhambra’s hidden gem for fresh, handcrafted Japanese cuisine.
          </h2>
          
                 <p className='body-text'>
            We specialize in fresh Sushi, handcrafted Specialty Rolls, traditional Ramen, Teriyaki dishes, and authentic Japanese appetizers!
            </p>
            <p className='body-text'>
            Fresh ingredients, traditional techniques, modern flavors - Order for delivery or pickup!
            </p>
        </div>}

        <div className="split-section" style={{
        
        }}>
          <div className="split-image" style={{
            flex: '1',
            backgroundImage: 'url("https://afag.imgix.net/sushi-yu/regular-8pcs-combo.jpg?w=800&auto=format")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: '400px'
          }}></div>
          <div className="split-content" style={{
            flex: '1',
            display: 'flex',
            backgroundColor: 'rgba(219, 38, 18, 0.9)',
            color: 'white',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '2rem',
            textAlign: 'center'
          }}>
            <h3 className="split-title" style={{ marginBottom: '1rem', fontSize: '1.8rem' }}>
              ALHAMBRA'S FAVORITE JAPANESE RESTAURANT!
            </h3>
            <p className="split-text">
              Sushi Yu in Alhambra, CA is a local favorite for fresh, beautifully plated sushi and authentic Japanese dishes. Enjoy premium Omakase nigiri, vibrant sashimi platters, and creative specialty rolls like the Super Tiger Roll, Garlic Albacore Roll, and Baked Baby Lobster Roll. The menu also features comforting bento boxes, tempura, and udon noodles — all made with care and top-quality ingredients. Perfect for lunch specials, date nights, or casual dinners, Sushi Yu blends friendly service with exceptional flavor. Dine in or order takeout to experience some of the best sushi in the San Gabriel Valley.
            </p>
            <p className="split-text">
              <Link to="/alhambra/order">Explore Our Menu</Link>
            </p>
          </div>
        </div>


        {shop ? <MenuCategoriesPreview categories={shop.menu.subMenus} /> : null}

        <h2 className="header-text">
          Our Locations
        </h2>
        <LocationsView shops={shops} />
      </div>
    </div>
  );
}




export class Header extends PureComponent {
  render() {
    // console.log('header props:', this.props)
    const shopId = this.props.shopId
    const basePath = this.props.basePath
    const locationName = this.props.shopId === 'shiso' ? 'North Hollywood' : 'Sherman Oaks'


    const backgroundULRBase = (basePath === '/shermanoaks') ?
    "https://afag.imgix.net/the-kluckin-chicken/nuggets.jpeg?w=1200&auto=format"
    : "https://afag.imgix.net/the-kluckin-chicken/kluckin-ten.png?w=1200&auto=format"
    return (
      <div className="location-page">

      {/* <Helmet>
        <title>Sushi Yu | Order Online</title>
      </Helmet> */}
      
        <div className="top-banner" style={{
          // backgroundImage: `url(${backgroundULRBase})`,
          // backgroundColor: "rgb(238,143,33)",
          // background:  `url(${backgroundULRBase}), linear-gradient(180deg, rgba(238,143,33,1) 0%, rgba(226,90,39,1) 100%)`,
          // backgroundSize: "contain",
          // background: "black"
        }}> 

        </div>

       

      <h2 id="order" style={{visibility: 'hidden', height: "0px", margin: "0", padding: "0"}}>Order Online</h2>

        <div className="ordering-menu">
          <AutoMenu
            subMenuFilter={subMenuFilter}
            altStyleA
            darkMode={true}
            // tagsToShow={['pizza']}
            width={500}></AutoMenu>
        </div>
      </div>
    );
  }
}


export function subMenuFilter (subMenu) {
  const tag = subMenu.tag || ''
  const now = new Date()
  const day = now.getDay() // Sunday - Saturday : 0 - 6
  const hours = now.getHours() //0 to 23
  const minutes = now.getMinutes() // 0 to 59
  const isWeekday = [1,2,3,4,5].indexOf(day) !== -1
  const isAllDayBreakfastMenu = tag.indexOf('breakfast') !== -1
  const isHidden = tag.indexOf('hidden') !== -1
  if (tag.indexOf('lunch') !== -1) {
    // M-F lunch: opens 11pm the night before, closes 4pm
    const isLunchDay = isWeekday && (hours < 16)
    const isNightBefore = [0,1,2,3,4].indexOf(day) !== -1 && (hours >= 23) // Sun-Thu 11pm
    return isLunchDay || isNightBefore
  }
  if (tag.indexOf('thursdays-only') !== -1) {
    // thursday promo category
    if (day === 4) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('tuesday-only') !== -1) {
    // thursday promo category
    if (day === 2) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('noho-breakfast') !== -1) {
    if ((day === 1) || (day === 2)) {
      if ((hours > 0) && (hours < 16)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  if (tag.indexOf('noho-dinner') !== -1) {
    return true
    // thursday promo category
    // if ((day === 1) || (day === 2)) {
    //   if ((hours > 16)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // } else {
    //   return true
    // }
  }

  if (tag.indexOf('promo-wing-it-wed') !== -1) {
    // wednesday promo category
    if (day === 3) {
      return true
    } else {
      return false
    }
  }

  if (isHidden) {
    return false
  }

  if (isAllDayBreakfastMenu && isWeekday) {
    return false
  }


  return true
}